import { findAnswers } from '../logics/questionBuilder';

export const makeQuizResults = (answers, correctAnswers) =>{
	const answersUnique = Array.from(new Set(correctAnswers));
	return answersUnique.map((correctAnswer)=>{
		if(!(correctAnswer in answers)){
			return {result : false, expected : correctAnswer, actual : null};
		}
		return {
			result : correctAnswer === answers[correctAnswer],
			expected : correctAnswer,
			actual : answers[correctAnswer]
		};
	});
};

export const makeRecipeResults = (answers, quizzes) => {
	return quizzes.map(quiz=>{
		const correctAnswer = findAnswers(quiz.question).answers;
		const results = makeQuizResults((answers&&answers[quiz.id]) || {}, correctAnswer);
		const explanation = quiz.explanation || '';
		return {result : results.every(val=>val.result), values : results, explanation, question:quiz.question };
	});
};

export const makeScore = (testResults) => {
	const passed = testResults.filter(result=>result.result);
	return {
		passed : passed.length,
		questionCount : testResults.length,
		results : testResults
	};
};
